"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
require("cn-next/es/icon/style");
var _icon = _interopRequireDefault(require("cn-next/es/icon"));
require("cn-next/es/menu/style");
var _menu = _interopRequireDefault(require("cn-next/es/menu"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pickOthers = _utils.obj.pickOthers;
var bindCtx = _utils.func.bindCtx;
var CascaderMenuItem = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(CascaderMenuItem, _Component);
  function CascaderMenuItem(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      loading: false
    };
    bindCtx((0, _assertThisInitialized2["default"])(_this), ['handleExpand', 'handleClick', 'handleMouseEnter', 'handleKeyDown', 'removeLoading']);
    return _this;
  }
  var _proto = CascaderMenuItem.prototype;
  _proto.addLoading = function addLoading() {
    this.setState({
      loading: true
    });
  };
  _proto.removeLoading = function removeLoading() {
    this.setState({
      loading: false
    });
  };
  _proto.setLoadingIfNeed = function setLoadingIfNeed(p) {
    if (p && typeof p.then === 'function') {
      this.addLoading();
      p.then(this.removeLoading)["catch"](this.removeLoading);
    }
  };
  _proto.handleExpand = function handleExpand(focusedFirstChild) {
    this.setLoadingIfNeed(this.props.onExpand(focusedFirstChild));
  };
  _proto.handleClick = function handleClick() {
    this.handleExpand(false);
  };
  _proto.handleMouseEnter = function handleMouseEnter() {
    this.handleExpand(false);
  };
  _proto.handleKeyDown = function handleKeyDown(e) {
    if (!this.props.disabled) {
      if (e.keyCode === _utils.KEYCODE.RIGHT || e.keyCode === _utils.KEYCODE.ENTER) {
        if (this.props.canExpand) {
          this.handleExpand(true);
        }
      } else if (e.keyCode === _utils.KEYCODE.LEFT || e.keyCode === _utils.KEYCODE.ESC) {
        this.props.onFold();
      } else if (e.keyCode === _utils.KEYCODE.SPACE) {
        this.handleExpand(false);
      }
    }
  };
  _proto.render = function render() {
    var _cx;
    var _this$props = this.props,
      prefix = _this$props.prefix,
      className = _this$props.className,
      menu = _this$props.menu,
      disabled = _this$props.disabled,
      selected = _this$props.selected,
      onSelect = _this$props.onSelect,
      expanded = _this$props.expanded,
      canExpand = _this$props.canExpand,
      expandTriggerType = _this$props.expandTriggerType,
      checkable = _this$props.checkable,
      checked = _this$props.checked,
      indeterminate = _this$props.indeterminate,
      checkboxDisabled = _this$props.checkboxDisabled,
      onCheck = _this$props.onCheck,
      children = _this$props.children;
    var others = pickOthers(Object.keys(CascaderMenuItem.propTypes), this.props);
    var loading = this.state.loading;
    var itemProps = (0, _extends2["default"])({
      className: (0, _classnames["default"])((_cx = {}, _cx[prefix + "cascader-menu-item"] = true, _cx[prefix + "expanded"] = expanded, _cx[className] = !!className, _cx)),
      disabled: disabled,
      menu: menu,
      onKeyDown: this.handleKeyDown,
      role: 'option'
    }, others);
    if (!disabled) {
      if (expandTriggerType === 'hover') {
        itemProps.onMouseEnter = this.handleMouseEnter;
      } else {
        itemProps.onClick = this.handleClick;
      }
    }
    var Item, title;
    if (checkable) {
      Item = _menu["default"].CheckboxItem;
      itemProps.checked = checked;
      itemProps.indeterminate = indeterminate;
      itemProps.checkboxDisabled = checkboxDisabled;
      itemProps.onChange = onCheck;
    } else {
      Item = _menu["default"].Item;
      itemProps.selected = selected;
      itemProps.onSelect = onSelect;
    }
    if (typeof children === 'string') {
      title = children;
    }
    return /*#__PURE__*/_react["default"].createElement(Item, (0, _extends2["default"])({
      title: title
    }, itemProps), children, canExpand ? loading ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      className: prefix + "cascader-menu-icon-right " + prefix + "cascader-menu-icon-loading",
      type: "loading"
    }) : /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      className: prefix + "cascader-menu-icon-right " + prefix + "cascader-menu-icon-expand",
      type: "arrow-right"
    }) : null);
  };
  return CascaderMenuItem;
}(_react.Component);
exports["default"] = CascaderMenuItem;
CascaderMenuItem.menuChildType = 'item';
CascaderMenuItem.propTypes = {
  prefix: _propTypes["default"].string,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  selected: _propTypes["default"].bool,
  onSelect: _propTypes["default"].func,
  expanded: _propTypes["default"].bool,
  canExpand: _propTypes["default"].bool,
  menu: _propTypes["default"].any,
  expandTriggerType: _propTypes["default"].oneOf(['click', 'hover']),
  onExpand: _propTypes["default"].func,
  onFold: _propTypes["default"].func,
  checkable: _propTypes["default"].bool,
  checked: _propTypes["default"].bool,
  indeterminate: _propTypes["default"].bool,
  checkboxDisabled: _propTypes["default"].bool,
  onCheck: _propTypes["default"].func,
  children: _propTypes["default"].node
};
module.exports = exports.default;
module.exports.default = exports.default;